export const QUERY_KEY = {
  DEPARTMENTS_ALL: 'departments-all',
  DEPARTMENT_SEARCH: 'department-search',
  DEPARTMENT_DETAILS: 'department-details',
  USER_GET: 'admin-user-get',
  USER_SEARCH: 'admin-user-search',
  IDN_GET: 'idn-get',
  IDN_SEARCH: 'idn-search',
  PATIENT_SEARCH: 'patient-search',
  USER_ACTIVATION_DATA: 'user-activation-data',
  PATIENT_PROFILE_DETAILS: 'patient-profile-details',
  USER_STATUS: 'user-status',
} as const;

export const MUTATION_KEY = {
  DEPARTMENT_CREATE: 'department-create',
  DEPARTMENT_UPDATE: 'department-update',
  DEPARTMENT_ARCHIVE: 'department-archive',
  DEPARTMENT_RESTORE: 'department-restore',
  IDN_CREATE: 'idn-create',
  IDN_UPDATE: 'idn-update',
  USER_CREATE: 'admin-user-create',
  USER_UPDATE: 'admin-user-update',
  USER_ARCHIVE: 'admin-user-archive',
  USER_RESTORE: 'admin-user-restore',
  LOGIN: 'login',
  PATIENT_CREATE: 'patient-create',
  PATIENT_UPDATE: 'patient-update',
  PATIENT_SETTINGS_UPDATE: 'patient-settings-update',
  PATIENT_SEARCH_VERIFY: 'patient-search-verify',
  USER_ACTIVATION_UPDATE: 'user-activation-update',
  USER_CONSENTS: 'user-consents',
} as const;
